import './WorkDirection.module.scss';
import style from './WorkDirection.module.scss';
import React, {forwardRef, useEffect, useLayoutEffect, useRef, useState} from "react";
import ScrollButton from "../../ScrollButton/ui/ScrollButton";
import {getWorkDirectionCard, WorkDirection} from "../../../axios/api";
import {Download, Laptop, Microscope} from "../../../assets";
import EllipsePattern from "../../../images/background/pattert_ellipse.svg";

const Item = forwardRef<HTMLDivElement, WorkDirection>(({title, description, manual, about, image}, ref) => {
    return (
        <div className={style.element} ref={ref}>
            <img className={style.imageWorkDir} src={image} alt={title}/>
            <div className={style.infoWorkDir}>
                <div className={style.title}>{title}</div>
                {description &&
                    <div className={style.description} dangerouslySetInnerHTML={{__html: description}}></div>}
            </div>
            <div className={style.controlPanel}>
                {about && <a href={about.replace('http://', 'https://')}
                             download={true}
                             className={style.Button}>О программе
                    <img src={Download}
                         className={style.ButtonIcon}/></a>}
                {manual && <a href={manual.replace('http://', 'https://')}
                              download={true}
                              className={style.Button}>Руководство
                    <img src={Download}
                         className={style.ButtonIcon}/></a>}
            </div>
            <img src={EllipsePattern} className={style.backgroundPattern} alt=""/>
        </div>
    );
});

export default function WorkDirectionScroll(props: any) {
    const [workDirection, setWorkDirection] = useState<WorkDirection[] | null>(null);

    const scrollRef = useRef<HTMLDivElement>(null);
    const itemRef = useRef<HTMLDivElement>(null);

    const [isLeftScrollActive, setLeftScrollActive] = useState(true);
    const [isRightScrollActive, setRightScrollActive] = useState(false);

    const [scrollOffset, setScrollOffset] = useState(0);
    const [isAutoScroll, setIsAutoScroll] = useState(true);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const autoScrollInterval = 4000;

    // запрос на получение членов команды
    useEffect(() => {
        getWorkDirectionCard().then(setWorkDirection).catch(console.error);
    }, []);

    // хук автоскролла
    useEffect(() => {
        if (!isAutoScroll || window.innerWidth <= 800) return;
        const interval = setInterval(() => {
            if (scrollRef.current) {
                scrollRight();
            }
        }, autoScrollInterval);

        return () => clearInterval(interval);
    }, [isAutoScroll]);


    // отслеживание изменения окна
    const handleResize = () => {
        if (itemRef.current) {
            setScrollOffset(itemRef.current.offsetWidth); // Обновляем ширину при изменении окна
        }
    };


    // Сброс таймера автоскролла при ручном скролле
    const resetAutoScroll = () => {
        setIsAutoScroll(false);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setIsAutoScroll(true), autoScrollInterval);
    };

    // хук отслеживания состояния кнопок
    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef.current) {
                const currentScrollLeft = scrollRef.current.scrollLeft;
                const maxScrollLeft = scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
                if (currentScrollLeft === 0) {
                    setLeftScrollActive(true);
                } else if (currentScrollLeft < maxScrollLeft) {
                    setRightScrollActive(false);
                    setLeftScrollActive(false);
                }
            }
        };

        const currentScrollRef = scrollRef.current;
        if (currentScrollRef) {
            currentScrollRef.addEventListener('scroll', handleScroll); // Добавляем обработчик события скролла
        }

        return () => {
            if (currentScrollRef) {
                currentScrollRef.removeEventListener('scroll', handleScroll); // Убираем обработчик события при размонтировании
            }
        };
    }, []);

    // Проверяем, достиг ли скролл конца
    const checkScrollEnd = () => {
        if (!scrollRef.current) return false;
        const {scrollLeft, scrollWidth, clientWidth} = scrollRef.current;

        return scrollLeft + clientWidth >= scrollWidth - 1;
    };

    //  скролл в начало контейнера
    const scrollBegining = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({left: -scrollRef.current.scrollLeft, behavior: 'smooth'});
        }
    };

    // скролл влево на scrollOffset
    const scrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({left: -scrollOffset, behavior: 'smooth'});
        }
        resetAutoScroll();
    };

    // скролл вправо на scrollOffset
    const scrollRight = () => {
        if (scrollRef.current) {
            if (!checkScrollEnd()) {
                scrollRef.current.scrollBy({left: scrollOffset, behavior: 'smooth'});
            } else {
                scrollBegining();
            }
        }
        resetAutoScroll();
    };

    // получение ширины одного элемента при первом рендере
    useEffect(() => {
        const observer = new MutationObserver(() => {
            if (itemRef.current) {
                setScrollOffset(itemRef.current.offsetWidth);
                observer.disconnect(); // Остановить отслеживание после появления элемента
            }
        });
        observer.observe(document.body, {childList: true, subtree: true});

        return () => observer.disconnect();
    }, []);

    return (
        <div className={style.body}>
            <div className={style.header}>
                <h2 className={style.title}><img src={Laptop}/>Продукты и решения</h2>

                <div className={style.scrollButtonContainer}>
                    <div className={style.leftScroll}>
                        <ScrollButton disabled={isLeftScrollActive} direction={"left"} onScroll={scrollLeft}/>
                    </div>
                    <div className={style.rightScroll}>
                        <ScrollButton disabled={isRightScrollActive} direction={"right"} onScroll={scrollRight}/>
                    </div>
                </div>
            </div>

            <div className={style.container} ref={scrollRef}>
                {workDirection?.map((item, index) => (
                    <Item key={index}
                          ref={index === 0 ? itemRef : null}
                          title={item.title}
                          description={item.description}
                          manual={item.manual}
                          about={item.about}
                          image={process.env.REACT_APP_IMAGE_URL + item.image}></Item>
                ))}
            </div>
        </div>
    )
}
